import { API_URL } from '@src/config/api';

export const urlFromPath = (path: string): string => {
  return `${API_URL}/${path}`;
};
